import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import {
  useSendMyDataMutation,
  updateRepeater,
  updateProgress,
  updateScore,
  updateHistory,
  updateOnBoarding,
} from 'store/user';

import type { ApiData } from 'types/post';

/**
 * リセットボタンの振る舞いを管理するカスタムフックを提供します。
 * @return {Object} handleResetとisUpdatingを返します。handleResetはリセットボタンが押されたときのアクションを実行します。isUpdatingはデータの更新状況を示します。
 */
export const useResetButton = () => {
  const dispatch = useDispatch();

  // データ一式をPOST
  const [
    postUser, // mutation trigger
    { isLoading: isUpdating }, // mutation state
  ] = useSendMyDataMutation();

  // 初回訪問完了フラグをPOST
  const handleRepeater = useCallback(async () => {
    const sendData: ApiData = {
      progress: [],
      repeater: false,
      history: '',
    };
    await postUser({ value: sendData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // オンボーディング完了
  /**
   * リセットボタンが押されたときのアクションを実行します。Reduxストアのユーザーデータをリセットし、画面を最上部にスクロールします。
   */
  const handleReset = useCallback(async () => {
    await handleRepeater();
    dispatch(updateHistory(''));
    dispatch(updateRepeater(false));
    dispatch(updateProgress([]));
    dispatch(updateScore(-1));
    dispatch(updateOnBoarding(1));
    window.scrollTo(0, 0);
  }, [handleRepeater, dispatch]);
  return { handleReset, isUpdating };
};
